(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lisa-video-cover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-video-cover')) {
  const frameCache = new Map();
  let captureQueue = Promise.resolve();

  const captureFrame = (source) => new Promise((resolve) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    let finished = false;
    let target = null;

    const finish = (frame) => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      video.removeAttribute('src');
      video.load();
      resolve(frame);
    };

    const draw = () => {
      if (finished || target === null || video.seeking || video.readyState < 2) return;
      if (Math.abs(video.currentTime - target) > 0.1) return;
      try {
        const canvas = document.createElement('canvas');
        const scale = Math.min(1, 960 / Math.max(video.videoWidth, video.videoHeight));
        canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        finish(canvas.toDataURL('image/jpeg', 0.85));
      } catch {
        finish(null);
      }
    };

    const timeout = setTimeout(() => finish(null), 15000);
    video.addEventListener('error', () => finish(null), { once: true });
    video.addEventListener('loadedmetadata', () => {
      if (finished) return;
      if (!Number.isFinite(video.duration) || video.duration <= 0) return finish(null);
      target = Math.min(1, video.duration / 2);
      video.currentTime = target;
    }, { once: true });
    video.addEventListener('seeked', draw);
    video.addEventListener('loadeddata', draw);
    video.src = source;
    video.load();
  });

  customElements.define('lisa-video-cover', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready || !this.dataset.source) return;
      if (!('IntersectionObserver' in window)) {
        this.loadFrame();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadFrame();
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async loadFrame() {
      const source = this.dataset.source;
      if (!frameCache.has(source)) {
        const pending = captureQueue.then(() => captureFrame(source));
        frameCache.set(source, pending);
        captureQueue = pending.catch(() => null);
      }
      const frame = await frameCache.get(source);
      const image = this.querySelector('img');
      if (!frame || !image || !this.isConnected) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = frame;
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
